import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

export default {
  async fetchSupervisors(query) {
    const url = `${URL}v1/cms/supervisors${query}`;
    return (await httpClient.get(url)).data;
  },
  async createSupervisor(payload) {
    const url = `${URL}v1/cms/supervisors`;
    return await httpClient.post(url, payload);
  },
  async updateSupervisor(supervisorId, payload) {
    const url = `${URL}v1/cms/supervisors/${supervisorId}`;
    return await httpClient.put(url, payload);
  },
  async removeSupervisor(supervisorId) {
    const url = `${URL}v1/cms/supervisors/${supervisorId}`;
    return await httpClient.delete(url);
  },
  async fetchVolunteerGroups() {
    const url = `${URL}cms/volunteer-groups`;
    return (await httpClient.get(url)).data;
  },
  async resetSupervisorPassword(supervisorId) {
    const url = `${URL}v1/cms/supervisors/${supervisorId}/reset-password`;
    return await httpClient.post(url);
  },
};
